// Catalogue central des images réutilisées depuis le dépôt sœur
// macha-vide-maison (mêmes propriétaires, cf. CLAUDE.md). Voir
// src/docs/CLAUDE_CODE_REUTILISATION_IMAGES_MACHA_VERS_VMB.md pour la
// spécification complète et scripts/sync-owned-macha-images.js pour la copie.
//
// Règle : un `alt` ne doit jamais affirmer une localisation ou une réalisation
// non prouvée (pas de "à Uccle", pas de date, pas de nom de client).

export const images = {
  "hero-accueil": {
    src: "/images/hero/vide-maison-bruxelles-hero.webp",
    width: 1600,
    height: 1067,
    alt: "Camion Vide Maison Bruxelles, équipe chargeant un meuble, Atomium et hôtel de ville en arrière-plan",
    rightsStatus: "owned",
  },
  "realisations-avant-1": {
    src: "/images/realisations/piece-avant-debarras-1.webp",
    width: 1086,
    height: 1448,
    alt: "Pièce encombrée de meubles et objets avant une intervention de débarras",
    rightsStatus: "owned",
    sourceOrigin: { site: "macha-vide-maison.be", originalPath: "public/achievements/before/vide-maison1.png" },
  },
  "realisations-apres-1": {
    src: "/images/realisations/piece-apres-debarras-1.webp",
    width: 1086,
    height: 1448,
    alt: "La même pièce vidée et nettoyée après l'intervention",
    rightsStatus: "owned",
    sourceOrigin: { site: "macha-vide-maison.be", originalPath: "public/achievements/after/vide-maison1.png" },
  },
  "realisations-avant-2": {
    src: "/images/realisations/piece-avant-debarras-2.webp",
    width: 1086,
    height: 1448,
    alt: "Meubles et cartons entassés avant un débarras",
    rightsStatus: "owned",
    sourceOrigin: { site: "macha-vide-maison.be", originalPath: "public/achievements/before/vide-maison2.png" },
  },
  "realisations-apres-2": {
    src: "/images/realisations/piece-apres-debarras-2.webp",
    width: 1086,
    height: 1448,
    alt: "Pièce vidée après évacuation des meubles et encombrants",
    rightsStatus: "owned",
    sourceOrigin: { site: "macha-vide-maison.be", originalPath: "public/achievements/after/vide-maison2.png" },
  },
  "realisations-avant-3": {
    src: "/images/realisations/piece-avant-debarras-3.webp",
    width: 1086,
    height: 1448,
    alt: "Espace encombré avant le tri et l'évacuation",
    rightsStatus: "owned",
    sourceOrigin: { site: "macha-vide-maison.be", originalPath: "public/achievements/before/vide-maison3.png" },
  },
  "realisations-apres-3": {
    src: "/images/realisations/piece-apres-debarras-3.webp",
    width: 1086,
    height: 1448,
    alt: "Pièce nettoyée et libérée après l'intervention",
    rightsStatus: "owned",
    sourceOrigin: { site: "macha-vide-maison.be", originalPath: "public/achievements/after/vide-maison3.png" },
  },
  "realisations-avant-4": {
    src: "/images/realisations/piece-avant-debarras-4.webp",
    width: 1448,
    height: 1086,
    alt: "Pièce encombrée avant débarras, vue d'ensemble",
    rightsStatus: "owned",
    sourceOrigin: { site: "macha-vide-maison.be", originalPath: "public/achievements/before/vide-maison4.png" },
  },
  "realisations-apres-4": {
    src: "/images/realisations/piece-apres-debarras-4.webp",
    width: 1448,
    height: 1086,
    alt: "Même vue, pièce vidée et prête à être remise en état",
    rightsStatus: "owned",
    sourceOrigin: { site: "macha-vide-maison.be", originalPath: "public/achievements/after/vide-maison4.png" },
  },
  "rachat-bijoux-or": {
    src: "/images/rachat-objets/bijoux-or.webp",
    width: 1536,
    height: 1024,
    alt: "Exemple de bijoux et montres en or pouvant faire l'objet d'un rachat",
    rightsStatus: "owned",
    sourceOrigin: { site: "macha-vide-maison.be", originalPath: "public/images/rachat/bijoux-or.png" },
  },
  "rachat-montres": {
    src: "/images/rachat-objets/montres.webp",
    width: 1536,
    height: 1024,
    alt: "Exemple de montres de marque examinées avant estimation",
    rightsStatus: "owned",
    sourceOrigin: { site: "macha-vide-maison.be", originalPath: "public/images/rachat/montres.png" },
  },
  "rachat-argenterie": {
    src: "/images/rachat-objets/argenterie.webp",
    width: 1536,
    height: 1024,
    alt: "Exemple d'argenterie et de vaisselle ancienne pouvant être rachetée",
    rightsStatus: "owned",
    sourceOrigin: { site: "macha-vide-maison.be", originalPath: "public/images/rachat/argenterie.png" },
  },
  "rachat-tableaux": {
    src: "/images/rachat-objets/tableaux.webp",
    width: 1535,
    height: 1025,
    alt: "Exemple de tableaux et objets d'art examinés avant valorisation",
    rightsStatus: "owned",
    sourceOrigin: { site: "macha-vide-maison.be", originalPath: "public/images/rachat/tableaux.png" },
  },
  "rachat-meuble-ancien": {
    src: "/images/rachat-objets/meuble-ancien.webp",
    width: 1536,
    height: 1024,
    alt: "Exemple de mobilier ancien pouvant être racheté lors d'un débarras",
    rightsStatus: "owned",
    sourceOrigin: { site: "macha-vide-maison.be", originalPath: "public/images/rachat/meuble-ancien.png" },
  },
  "rachat-collection": {
    src: "/images/rachat-objets/collection.webp",
    width: 1535,
    height: 1024,
    alt: "Exemple d'objets de collection pouvant faire l'objet d'un rachat",
    rightsStatus: "owned",
    sourceOrigin: { site: "macha-vide-maison.be", originalPath: "public/images/rachat/collection.png" },
  },
};

export function getImage(id) {
  const image = images[id];
  if (!image) {
    throw new Error(`Image inconnue dans le catalogue : "${id}"`);
  }
  return image;
}
